const state = {
    showReceiptPaper: false,
    selectedReceipt: null,
};

const getters = {
    getShowReceiptPaperModal(state){
        return state.showReceiptPaper;
    },
    getSelectedReceipt(state){
        if(!state.selectedReceipt){
            state.selectedReceipt = getters.getNewReceipt;
        }
        return state.selectedReceipt;
    },

    getNewReceipt(state, getters, rootGetters){
        return {
            code: '',
            users_id: '',
            invoices_id: '',
            payment_date: '',
            description: '',
            deleted_by_user: '',
            delete_reason: '',
            delete_at: '',
            created_at: '',
            updated_at: '',

            // sell: rootGetters['Sell/getNewSell'],
            // this.$store.getters.getNewSell,

        };
    },

};

const mutations = {
    setShowReceiptPaperModal(state, payload){
        state.showReceiptPaper = payload;
    },
    setSelectedReceipt(state, payload){
        state.selectedReceipt = payload;
    }
};

const actions = {
    setShowReceiptPaperModal({commit}, payload){
        commit('setShowReceiptPaperModal', payload);
    },
    setSelectedReceipt({commit}, payload){
        commit('setSelectedReceipt', payload);
    },
};

export default {
    state,
    getters,
    mutations,
    actions
};

